/**
 * Design-canvas components — ported from Claude Design handoff bundle
 * (cafMiLPXGkq4tDRsvkDtxw, 2026-05-19).
 *
 * These complement (not replace) the existing `components/ui/` primitives.
 * Use for new pages that follow the Tier-1 design system; existing routes
 * keep using `components/ui/`.
 */
export { Bouchon } from "./Bouchon";
export { Boule } from "./Boule";
export { Avatar } from "./Avatar";
export { Btn } from "./Btn";
export { DesignCard } from "./Card";
export { Chip } from "./Chip";
export { Dots } from "./Dots";
export { Logo } from "./Logo";
export { TopBar } from "./TopBar";
export { BottomNav } from "./BottomNav";
export * as Icons from "./icons";
export { SideNav } from "./SideNav";
export type { NavId } from "./SideNav";
export { PageShell } from "./PageShell";
export { Skeleton, SkeletonCard } from "./Skeleton";
